import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/feature/Reveal";

const steps = [
  {
    step: "01",
    title: "先把时间排好",
    desc: "把能确认时间点的公开信息按先后排列，形成一条可对照的基础时间线。",
  },
  {
    step: "02",
    title: "再归类材料性质",
    desc: "把材料分为一手材料、间接材料与当事方声明三类，标注各自的证明力强弱。",
  },
  {
    step: "03",
    title: "最后给结论倾向",
    desc: "只有材料足以支撑时才下结论，否则保留待跟进状态，并说明还缺哪一环。",
  },
];

export default function EvidenceSpotlight() {
  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
        <Reveal>
          <div className="relative h-72 w-full overflow-hidden rounded-lg bg-background-200 md:h-96">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20workspace%20with%20open%20notebook%2C%20fountain%20pen%20and%20a%20cup%20of%20tea%20on%20a%20cream%20desk%2C%20soft%20morning%20light%2C%20calm%20focused%20atmosphere%2C%20muted%20amber%20and%20deep%20green%20accents%2C%20cinematic%20still%20life%20photography%2C%20high%20detail%2C%20no%20people&width=1200&height=900&seq=guada-method-01&orientation=landscape"
              alt="整理事件材料与时间线的工作场景"
              title="诱惑吃瓜 证据链整理方法"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute bottom-4 left-4 right-4 rounded-md border border-background-50/30 bg-background-50/95 p-4 backdrop-blur-sm md:left-6 md:right-auto md:max-w-xs">
              <p className="flex items-center gap-2 text-xs font-semibold text-primary-700">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-shield-check-line" aria-hidden="true"></i>
                </span>
                内容原则
              </p>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                所有材料均标注来源类型，读者可自行回溯核对；不采用无法验证的匿名爆料。
              </p>
            </div>
          </div>
        </Reveal>

        <div>
          <SectionHeading
            eyebrow="我们怎么做证据链"
            title="三步拆解，让结论经得起复核"
            desc="比起下判断，我们更在意判断是怎么来的。每一步都会在正文中留下可检查的痕迹。"
          />

          <ol className="mt-8 space-y-4">
            {steps.map((item, index) => (
              <Reveal key={item.step} delay={index * 70}>
                <li className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 font-heading text-sm font-bold text-primary-700">
                    {item.step}
                  </span>
                  <span>
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                      {item.desc}
                    </p>
                  </span>
                </li>
              </Reveal>
            ))}
          </ol>

          <Link
            to="/about"
            className="mt-6 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            了解完整的复盘标准
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}